var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"action-block flex-wrap flex-centerize flex-column"},[_c('AppIcon',{attrs:{"name":_setup.entity.icon}}),_c('div',[_c('span',{staticClass:"tit"},[_vm._v(_vm._s(_setup.entity.title))])]),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',[_vm._v("Only visible in workflow view")])])
}]

export { render, staticRenderFns }